module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/close-95cec020e08e92ba032a260b53b48067.svg&quot;;"